import type { ResolvedComponent as ReactComponent } from "@inertiajs/react";

import AppLayout from "@admin/layouts/AppLayout";

const pages = import.meta.glob<ReactComponent>(["../pages/**/*.tsx"], {
  eager: false,
});

export const inertiaDefaults = {
  form: {
    forceIndicesArrayFormatInFormData: false,
  },
  visitOptions: () => {
    return {
      preserveScroll: true,
      preserveState: true,
    };
  },
};

export const resolvePageComponent = (name: string) => {
  const page = pages[`../pages/${name}.tsx`];
  if (!page) {
    throw new Error(`Missing Inertia page component: '${name}'.`);
  }

  return page();
}

export function resolveDefaultLayout(name: string) {
  if (name.includes("test") || name.startsWith("public/")) {
    return undefined;
  }

  return AppLayout;
}
